import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Base } from "components/template";
import { InputControl, SelectControl } from "components/organism";
import { ProgressBar } from "components/molecules";
import { Button } from "components/atoms";
import { companyDataSchema } from "_config/formSchemas";
import { useLocalStorage, useOnBoarding } from "_hooks";
import { companyData } from "_config/store/onBoarding/onBoarding.thunk";

const prefix = "v-company-data";

const CompanyData = () => {
  const dispatch = useDispatch();
  const { register, handleSubmit, formState: { errors }, watch } = useForm({
    resolver: yupResolver(companyDataSchema)
  });
  const [onBoarding, setOnBoarding] = useLocalStorage("onBoarding");
  const { state } = useLocation();
  const navigate = useNavigate();
  const { countryKey, producttypeKey } = watch();

  const {
    countries,
    countriesIsLoading,
    productTypes,
    productTypesIsLoading,
  } = useOnBoarding();

  const { data: response, isLoading } = useSelector((s) => s.onBoarding.companyData);

  const onSubmit = (data) => dispatch(companyData(onBoarding?._id, data));

  useEffect(() => {
    if (response !== null) {
      setOnBoarding(response);
      setTimeout(() => navigate("/account/initialData", { state }), 200);
    }
  }, [response]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Base 
      align="normal"
      header={<ProgressBar max={6} progress={3} />}
      headerClass={"mx-auto w-full sm:w-2/3 md:w-3/5 lg:w-4/12 max-w-[550px] mt-10 mb-0"}
    >
      <div className={`${prefix} flex flex-wrap flex-col p-3 mx-auto w-full sm:w-2/3 md:w-3/5 lg:w-4/12 max-w-[550px]`}>
        <div className="flex flex-wrap flex-col gap-3 ">
          
          <p className="text-center text-3xl font-bold mx-auto mt-5 mb-2">Datos de la empresa</p>
        
          <form 
            className="flex flex-wrap flex-col gap-7"
            onSubmit={handleSubmit(onSubmit)}
          > 
            <InputControl
              errors={errors?.enterpriseName}
              label="Nombre"
              name="enterpriseName"
              orientation="vertical"
              inputProps={{
                autoComplete: "off",
                ...register("enterpriseName"),
                placeholder: "Ej. ACME"
              }}
            />

            <SelectControl
              errors={errors?.countryKey}
              selectProps={{
                emptyLabel: "Selecciona una opción",
                ...register("countryKey"),
                value: countryKey
              }}
              label="País donde opera la empresa"
              name="countryKey"
              orientation="vertical"
              options={countries?.map((c) => ({ label: c.title, value: c.code})) ?? []}
            />

            <SelectControl
              errors={errors?.producttypeKey}
              selectProps={{
                emptyLabel: "Selecciona una opción",
                value: producttypeKey,
                ...register("producttypeKey")
              }}
              label="Tipos de productos comercializados"
              name="producttypeKey"
              orientation="vertical"
              options={productTypes?.map((c) => ({ label: c.title, value: c.code})) ?? []}
            />

            <Button
              className="bg-primary text-white rounded-lg mt-5"
              disabled={countriesIsLoading || productTypesIsLoading || isLoading || !!Object.keys(errors).length}
              spin={isLoading}
              pulse={true}
              fullwidth
              type="submit"
            >Continuar</Button>
          </form>
        </div>
        
      </div>
    </Base>
  );
};

export default CompanyData;
